/**
 * Built-in features, for whose permissions are created programmatically when user logs in
 */
export const BuiltInFeatures = {
  IsSuperAccount: 'super-account',
  IsIntegrationAccount: 'integration-account',
  IsAdministrator: 'administrator',
  IsUser: 'user'
}

/**
 * Returns true if specified feature is a built-in one
 * @param name Feature name
 */
export function isBuiltInFeature (name) {
  return Object.values(BuiltInFeatures).includes(name)
}
